import { Box, CircularProgress } from '@mui/material'
import back from 'assets/images/wallpaper.login.png'
import { selectPortal } from 'features/portal/portalSlice'
import { useSelector } from 'react-redux'

const LoginBackground = ({
  children,
  loading = true,
  onlyImage = false,
  centerContent = false,
}) => {
  const portal = useSelector(selectPortal)

  const backgrounImage = portal?.portal?.fondo_login
    ? `/assets/images/${portal?.portal?.fondo_login}`
    : back

  const imageBg = {
    backgroundColor: 'background.default',
    backgroundImage: `url(${backgrounImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  }
  const white = {
    backgroundColor: 'background.default',
  }
  const bg = loading ? white : imageBg

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        width: '100vw',
        height: '100vh',
        display: centerContent ? 'flex' : 'block',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
        }}
      >
        {!onlyImage ? (
          <Box
            sx={{
              width: {
                xs: '100%',
                md: '45%',
              },
              height: {
                xs: '35%',
                md: '100%',
              },
              backgroundColor: 'white',
            }}
          />
        ) : null}
        <Box
          sx={{
            width: {
              xs: '100%',
              md: onlyImage ? '100%' : '55%',
            },
            height: {
              xs: onlyImage ? '100%' : '65%',
              md: '100%',
            },
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            ...bg,
          }}
        />
      </Box>
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          mx: {
            xs: 'auto',
          },
          mt: {
            xs: 2,
            md: 0,
          },
          px: { xs: 2, md: 10 },
          width: '100%',
          height: '100%',
          minWidth: {
            xs: 'auto',
            md: '380px',
          },
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'left',
          gap: 4,
        }}
      >
        <>{loading ? <CircularProgress /> : <>{children}</>}</>
      </Box>
    </Box>
  )
}

export default LoginBackground
